module.exports = __webpack_public_path__ + "static/media/Windturbine.cc16da73.png";